import { lazy } from 'react';
import { Redirect } from 'react-router-dom';
const CommunityRoutes = [
  {
    path: '/community',
    exact: true,
    component: () => <Redirect to="/community/home" />
  },

  {
    path: '/community/home',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Banner'))
  },
  {
    path: '/community/refer',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Banner/Refer'))
  },
  {
    path: '/community/tasksandgoals',
    appLayout: true,
    component: lazy(() => import('../../views/community/component/taskAndGoals/index.js'))
  },
  {
    path: '/community/orgchart',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Banner/Refer/OrgChart.js'))
  },
  {
    path: '/community/myrefer',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Banner/Refer/Myrefer'))
  },
  {
    path: '/community/checkin',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Banner/CheckIn'))
  },
  {
    path: '/community/dashboard',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/TimeStamp'))
  },
  //EVENTS
  {
    path: '/community/events',
    appLayout: true,
    component: lazy(() => import('../../views/events/Events'))
  },
  {
    path: '/community/tournament/:id',
    appLayout: true,
    component: lazy(() => import('../../views/events/event/register/RegisterEvent'))
  },
  {
    path: '/events/:id',
    appLayout: true,
    component: lazy(() => import('../../views/events/event/eventDetails/PublicEventView'))
  },
  {
    path: '/tournaments/:id',
    appLayout: true,
    component: lazy(() => import('../../views/events/event/eventDetails/PublicTournamentsView'))
  },
  {
    path: '/community/members',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/memberList/MemberList'))
  },
  {
    path: '/community/members/:id',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/memberList/memberDetails'))
  },
  {
    path: '/community/group',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Group'))
  },
  {
    path: '/community/messenger',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Messenger'))
  },
  {
    path: '/community/inbox',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Inbox'))
  },
  {
    path: '/community/profile',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/index'))
  },
  {
    path: '/community/group/create',
    appLayout: true,
    component: lazy(() => import('../../views/community/component/Group/create'))
  },
  {
    path: '/community/abc/details/:groupId',
    appLayout: true,
    component: lazy(() => import('../../views/community/component/Group/detail'))
  },
  {
    path: '/community/user/:id',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/index'))
  },
  {
    path: '/community/group-details/:groupId',
    appLayout: true,
    component: lazy(() => import('../../views/community/component/Group/detail'))
  },
  {
    path: '/community/ranking',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Ranking'))
  },
  {
    path: '/community/member',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/memberList/memberDetails'))
  },
  //SHOP
  {
    path: '/community/shop/checkout',
    exact: true,
    className: 'ecommerce-application',
    component: lazy(() => import('../../views/shop/checkout'))
  },
  {
    path: '/community/shop',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/shop'))
  },
  {
    path: '/community/calendar',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/calendar'))
  },
  {
    path: '/community/calendar/booking/:id',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/calendar/booking'))
  },
  {
    path: '/booking/:link',
    component: lazy(() => import('../../views/calendar/booking/preview')),
    appLayout: false,
    layout: 'BlankLayout',
    meta: {
      publicRoute: true
    }
  },
  {
    path: '/community/shop/product-details/:id',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/shop/product-details'))
  },
  {
    path: '/community/membership/shop/:id',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/shop/membership/PublicCheckout'))
  },
  //course details in shop section
  {
    path: '/community/shop/course/:courseId',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/shop/home/course/ShopCourseDetails'))
  },
  {
    path: '/community/shop/course/checkout/:courseId',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/shop/home/course/CourseCheckout'))
  },
  //Supports
  {
    path: '/community/account-support',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/support/AccountSetting'))
  },
  {
    path: '/community/login-and-password',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/support/LoginAndPass'))
  },
  {
    path: '/community/policy-privacy',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/support/PolicyAndPrivacy'))
  },
  {
    path: '/community/shop-support',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/support/ShopSupport'))
  },
  {
    path: '/community/group-support',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/support/GroupSupport'))
  },
  {
    path: '/community/member-support',
    exact: true,
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Profile/support/MemberSupport'))
  },
  //Chat start here
  {
    path: '/community/message',
    appLayout: true,
    component: lazy(() => import('../../views/chats/ChatSection'))
  },
  {
    path: '/invoice-preview/:id',
    appLayout: true,
    component: lazy(() => import('../../views/finance/invoice/PublicInvoice'))
  },
  {
    path: '/payment/:id',
    appLayout: true,
    component: lazy(() => import('../../views/components/payment/PaymentStatusPage'))
  },
  {
    path: '/community/point-details',
    appLayout: true,
    component: lazy(() => import('../../views/community/tab/Banner/PointDetails'))
  }
];

export default CommunityRoutes;
